"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPrimitive = isPrimitive;
exports.typeOf = typeOf;
function isPrimitive(instance) {
    switch (typeof instance) {
        case "undefined":
        case "boolean":
        case "number":
        case "string":
        case "symbol":
            return true;
        default:
            return false;
    }
}
function typeOf(obj) {
    if (obj === null) {
        return "null";
    }
    const t = typeof obj;
    if (t === "object") {
        if (Array.isArray(obj)) {
            return "array";
        }
        if (obj instanceof Set) {
            return "set";
        }
        if (obj instanceof Map) {
            return "map";
        }
        if (obj instanceof Date) {
            return "date";
        }
        if (obj instanceof RegExp) {
            return "regexp";
        }
    }
    return t;
}
//# sourceMappingURL=type.js.map